import type {
  UsBankEarning,
  UsBankEarningOrder,
  UsBankEarningsPage,
} from 'src/interfaces/usBankTransactions'
import type { State } from '../reducers/types'

export const getUsBankEarnings = (state: State): UsBankEarning[] => {
  return state.usBankTransactions.earnings
}

export const getUsBankEarningsPagination = (state: State): UsBankEarningsPage['pagination'] => {
  return state.usBankTransactions.pagination
}

export const getUsBankEarningsLoading = (state: State): boolean => {
  return state.usBankTransactions.loading
}

export const getUsBankEarningsError = (state: State): string | null => {
  return state.usBankTransactions.error
}

export const getUsBankEarningOrders = (state: State): UsBankEarningOrder[] => {
  return state.usBankTransactions.orders
}

export const getUsBankEarningOrdersEarningId = (state: State): string | null => {
  return state.usBankTransactions.ordersEarningId
}

export const getUsBankEarningOrdersLoading = (state: State): boolean => {
  return state.usBankTransactions.ordersLoading
}

export const getUsBankEarningOrdersError = (state: State): string | null => {
  return state.usBankTransactions.ordersError
}
